import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Footer légal conforme aux CGU et RGPD
 * Affiché sur toutes les pages
 */
export const LegalFooter = () => {
  return (
    <footer 
      data-testid="legal-footer"
      className="bg-slate-950 border-t border-slate-800 py-6 px-4 mt-8"
    >
      <div className="max-w-7xl mx-auto">
        {/* Éditeur */}
        <div className="text-center mb-4">
          <p className="text-sm text-slate-400">
            <span className="text-slate-300 font-medium">Éditeur :</span> Dr STEPANIAN Tigran — médecin — RPPS 10101555802
          </p>
        </div>

        {/* Liens légaux */}
        <div className="flex flex-wrap justify-center gap-4 mb-4">
          <Link 
            to="/mentions-legales" 
            className="text-xs text-slate-500 hover:text-blue-400 transition-colors"
            data-testid="link-mentions-legales"
          >
            Mentions Légales & CGU
          </Link>
          <span className="text-slate-700">|</span>
          <Link 
            to="/confidentialite" 
            className="text-xs text-slate-500 hover:text-blue-400 transition-colors"
            data-testid="link-confidentialite"
          >
            Politique de confidentialité (RGPD)
          </Link>
          <span className="text-slate-700">|</span>
          <a 
            href="mailto:dr.stepanian.tigran@gmail.com" 
            className="text-xs text-slate-500 hover:text-blue-400 transition-colors"
            data-testid="link-contact"
          >
            Contact
          </a>
        </div>

        {/* Rappel réglementaire */}
        <div className="text-center">
          <p className="text-xs text-slate-600 leading-relaxed max-w-2xl mx-auto">
            Information médicale générale — ne constitue pas un dispositif médical.
            <br />
            Service gratuit en phase de lancement.
          </p>
        </div>
      </div>
    </footer>
  );
};
